const config = {
    dev: {
        app: {
            URL: "https://localhost:3000/",
            BASEDOMAIN: "localhost",
            BASENAME: "https://localhost:3000/",
            CDN: "https://localhost:3000/"
        },
        apiGateway: {
            URL: "http://localhost:9000/api",
            VERSION: "v1"
        }
    },
    prod: {
        app: {
            URL: "https://painel.firstoeat.com.br/",
            BASEDOMAIN: "firstoeat.com.br",
            BASENAME: "https://painel.firstoeat.com.br/",
            CDN: "https://painel.firstoeat.com.br/"
        },
        apiGateway: {
            URL: "https://api.firstoeat.com.br/api",
            VERSION: "v1"
        }
    }
};

module.exports = config.prod;
